import React from 'react';
import { Github } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 mt-24">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-semibold mb-4">Headline Spark</h3>
            <p className="text-gray-400">
              The best free blog title generator for content creators, marketers, and bloggers.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#how-to-use" className="hover:text-white">How to Use</a></li>
              <li><a href="#benefits" className="hover:text-white">Benefits</a></li>
              <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Connect</h3>
            <a href="https://github.com" className="flex items-center gap-2 hover:text-white">
              <Github className="w-5 h-5" />
              GitHub
            </a>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">© {new Date().getFullYear()} Headline Spark. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}